import React from 'react';
import styled from 'styled-components';
import { Button as AntButton } from 'antd';
export const Button = styled(AntButton) `
  &.ant-btn.ant-btn-background-ghost,
  &.ant-btn {
    /* Regular button */
    border-radius: 16px;
    background: var(--color-bg-main);
    padding: 0 16px;
    box-shadow: none;

    border: 1px solid var(--color-border-button-regular);
    color: var(--color-text-main);

    /* Clear ant transitions */
    transition: none;

    &:hover,
    &:focus,
    &:active {
      background: var(--color-bg-main);
      border: 1px solid var(--color-border-button-regular-hover);
      color: var(--color-text-button);
    }

    /*** Sizes ***/
    &.ant-btn-lg {
      border-radius: 20px;
      padding: 0 24px;
    }

    &.ant-btn-sm {
      height: 28px;
      font-size: 12px;
      border-radius: 14px;
      padding: 0 12px;
    }

    /*** Types ***/
    /* Primary blue */
    &.ant-btn-primary {
      background: var(--color-base-blue);
      border-color: var(--color-base-blue);
      color: var(--color-base-white);
      text-shadow: none;
    }

    &.ant-btn-primary:hover {
      border-color: var(--color-base-blue2);
      background: var(--color-base-blue2);
    }

    /* Danger regular */
    &.ant-btn-dangerous {
      border-color: var(--color-bg-button-danger);
      color: var(--color-bg-button-danger);
    }

    /* Danger primary */
    &.ant-btn-primary.ant-btn-dangerous,
    &.ant-btn-primary.ant-btn-dangerous:hover {
      background: var(--color-bg-button-danger);
      color: var(--color-base-white);
      border-color: var(--color-bg-button-danger);
    }

    /* Link & Text */
    &.ant-btn-text,
    &.ant-btn-link {
      background: none;
      border: none;
    }

    &.ant-btn-text {
      color: var(--color-text-main);
    }

    &.ant-btn-text:hover {
      color: var(--color-text-main-hover);
    }

    &.ant-btn-link {
      color: var(--color-text-link);
    }

    &.ant-btn-link:hover {
      color: var(--color-text-link-hover);
    }

    /* Disabled */
    &[disabled],
    &[disabled]:hover,
    &[disabled].ant-btn-dangerous,
    &[disabled].ant-btn-dangerous:hover {
      color: var(--color-text-button-disabled);
      background-color: var(--color-bg-button-disabled);
      border-color: var(--color-bg-button-disabled);
    }

    /*** Loading ***/
    &.ant-btn-loading,
    &.ant-btn-loading:hover {
      color: var(--color-text-button-disabled);
      background-color: var(--color-bg-button-disabled);
      border-color: var(--color-bg-button-disabled);
      cursor: not-allowed;
    }
    &.ant-btn-loading:before {
      opacity: 0;
    }

    /*** Icon only ***/
    &.ant-btn-icon-only {
      padding: 2.4px 0;
      border-radius: 2px;
    }

    &.ant-btn-background-ghost {
      background-color: transparent;
    }
  }
`;
export const ActionButton = styled(AntButton).attrs(() => ({ size: 'small' })) `
  border-radius: 12px;
  background: var(--color-bg-buttonaction);
  padding: 0 12px;
  color: var(--color-text-buttonaction);
  border-color: var(--color-bg-buttonaction);
  font-size: var(--font-size-xs);
  box-shadow: none;

  /* Clear ant transitions */
  transition: none;

  &:hover,
  &:focus,
  &:active {
    background: var(--color-bg-buttonaction-hover);
    border-color: var(--color-bg-buttonaction-hover);
    color: var(--color-text-buttonaction-hover);
  }

  &.ant-btn-primary {
    background: var(--color-bg-buttonpopup-primary);
    border-color: var(--color-bg-buttonpopup-primary);
    color: var(--color-text-buttonpopup-primary);
    text-shadow: none;
  }

  &.ant-btn-primary:hover {
    border-color: var(--color-bg-buttonpopup-primary-hover);
    background: var(--color-bg-buttonpopup-primary-hover);
  }

  &[disabled],
  &[disabled]:hover,
  &[disabled].ant-btn-dangerous,
  &[disabled].ant-btn-dangerous:hover {
    color: var(--color-text-buttonaction);
    background-color: var(--color-bg-buttonaction);
    border-color: var(--color-bg-buttonaction);
  }
`;
export const PopupButton = (props) => {
    const { type } = props;
    const ghost = type !== 'primary';
    return React.createElement(Button, Object.assign({ ghost: ghost, size: "small" }, props));
};
